import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import ServiceNestedAccordionItem from './ServiceNestedAccordionItem';
import './ServiceNestedAccordion.css';

const ServiceNestedAccordion = forwardRef(({ items, openAccordion, onToggle }, ref) => {
  const itemRefs = useRef({});

  useImperativeHandle(ref, () => ({
    scrollToItem: (itemId) => {
      const itemElement = itemRefs.current[itemId];
      if (itemElement) {
        const headerElement = itemElement.querySelector('.service-accordion-header');
        if (headerElement) {
          const rect = headerElement.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const navbarHeight = 170; // Fixed navigation height
          const offset = 80; // Space below navigation
          const targetPosition = rect.top + scrollTop - navbarHeight - offset;
          
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      }
    }
  }));

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className="service-details-section">
      <div className="service-accordion-container">
        {items.map((item) => (
          <ServiceNestedAccordionItem
            key={item.id}
            item={item}
            isOpen={openAccordion === item.id}
            onToggle={() => onToggle(item.id)}
            itemRef={(el) => (itemRefs.current[item.id] = el)}
          />
        ))}
      </div>
    </div>
  );
});

ServiceNestedAccordion.displayName = 'ServiceNestedAccordion';

export default ServiceNestedAccordion;

